import { render, staticRenderFns } from "./notificationsDetail.vue?vue&type=template&id=ec89070e&scoped=true"
import script from "./notificationsDetail.vue?vue&type=script&lang=ts"
export * from "./notificationsDetail.vue?vue&type=script&lang=ts"
import style0 from "./notificationsDetail.vue?vue&type=style&index=0&id=ec89070e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec89070e",
  null
  
)

export default component.exports